import axios from "axios"
import { handleResponse } from "."
import { BASE_URL } from "../utils/constant"

interface TokenAmount {
  amount: string
  decimals: number
  uiAmount: string
  uiAmountString: string
}

export interface TokenInfoResp {
  publicKey: string
  updateAuthority: string
  mint: string
  name: string
  symbol: string
  supply: TokenAmount
}

export interface TokenHoldingResp {
  uiAmount: string
}

const SERVICE_URL = `${BASE_URL}/tokens`

export class TokenService {
  public static getMetadata = async (id: string): Promise<TokenInfoResp> => {
    return handleResponse<TokenInfoResp>(
      axios.get(`${SERVICE_URL}/info`, {
        params: { id },
      }),
    )
  }

  public static getTokenHolding = async (tokenMintAddress: string, ownerIdentifier: string): Promise<TokenHoldingResp> => {
    return handleResponse<TokenHoldingResp>(
      axios.get(`${SERVICE_URL}/holding`, {
        params: { tokenMintAddress, ownerIdentifier },
      }),
    )
  }
}
